// complementary actions
export const CLEAR_INFO = '@@toyota/CLEAR_INFO';
export const CHANGE_LIST_PAGE = '@@toyota/CHANGE_LIST_PAGE';
export const CHANGE_LIST_PAGE_SIZE = '@@toyota/CHANGE_LIST_PAGE_SIZE';
